import { useState } from 'react'
import { DiaperBankPublic } from '../../utils/DiaperBankDTO'
import Modal from '../Modal'
import OTPVerification from '../auth/OTPVerification'

export default function VerificationModal({ diaperBank }: { diaperBank: DiaperBankPublic }) {
  const [modalShown, setModalShown] = useState<boolean>(false)
  const onClose = () => setModalShown(false)
  return (
    <>
      <Modal open={modalShown} onClose={onClose} title='Verify'>
        <OTPVerification diaperBank={diaperBank} onClose={onClose} />
      </Modal>
      <button className='w-full bg-wisteria py-4 px-4 z-20 text-center text-white text-sm cursor-pointer focus:outline-none' onClick={() => setModalShown(true)}>
        This diaper fund is not live. Click here to verify.
      </button>
    </>
  )
}
